import React from "react";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { BannerMock, CmsComponentProps } from "./types";

const BannerComponent: React.FC<CmsComponentProps> = ({ layout, items: userItems }) => {
  const items =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            description: i.description ?? "",
            img: i.img ?? "",
            link: i.link ?? "",
          }))
      : (mockData.banner as BannerMock[]);

  return (
    <CmsPreviewShell>
      <div className={`cms-banner cms-banner--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-banner__item">
            {item.img ? <img src={item.img} alt={item.title} /> : <div className="cms-banner__placeholder">{item.title || "이미지 없음"}</div>}
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default BannerComponent;
